'use client';

import { TouchProvider } from '@/components/ui/responsive-tooltip';
import { Toaster as SonnerToaster } from '@/components/ui/sonner';
import { useBreakpoint } from '@/hooks/tailwind';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFontAwesome, fas } from '@fortawesome/free-solid-svg-icons';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider as NextThemeProvider } from 'next-themes';
import { useEffect } from 'react';
library.add(fas, faFontAwesome);
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false
    }
  }
});
export function ClientLayout({
  children
}: {
  children: React.ReactNode;
}) {
  // Update the favicon based on the current color scheme
  useEffect(() => {
    const update_favicon = (e: MediaQueryListEvent) => {
      const favicon = document.querySelector("link[rel~='icon'][type='image/svg+xml']");
      if (favicon) {
        favicon.setAttribute('media', e.matches ? '(prefers-color-scheme: dark)' : '(prefers-color-scheme: light)');
      }
    };
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    // When the theme changes, update the favicon
    darkModeMediaQuery.addEventListener('change', update_favicon);
    return () => {
      darkModeMediaQuery.removeEventListener('change', update_favicon);
    };
  }, []);
  const {
    isAboveMd
  } = useBreakpoint('md');
  return <>
      <QueryClientProvider client={queryClient} data-sentry-element="QueryClientProvider" data-sentry-source-file="client.tsx">
        <TouchProvider data-sentry-element="TouchProvider" data-sentry-source-file="client.tsx">
          <NextThemeProvider attribute="class" data-sentry-element="NextThemeProvider" data-sentry-source-file="client.tsx">{children}</NextThemeProvider>
        </TouchProvider>
      </QueryClientProvider>
      <SonnerToaster richColors closeButton position={isAboveMd ? 'bottom-right' : 'top-center'} data-sentry-element="SonnerToaster" data-sentry-source-file="client.tsx" />
    </>;
}